<template>
  <stripe-bridge-dialog :open="open" :title="title" :busy="busy" @close="$emit('cancel')">
    <slot></slot>
    <div v-if="requireText" class="confirm-type">
      <span class="confirm-label">
        LIVE mode: type <strong>{{ requireText }}</strong> to confirm
      </span>
      <aha-input
        aria-label="Type the name to confirm"
        :value="typed"
        :disabled.prop="busy"
        @input="typed = $event.detail && typeof $event.detail.value === 'string' ? $event.detail.value : typed"
      ></aha-input>
    </div>
    <aha-alert v-if="error" type="error" size="small">{{ error }}</aha-alert>
    <template slot="footer">
      <aha-button variant="secondary" :disabled="busy" @click="$emit('cancel')">Cancel</aha-button>
      <aha-button
        :variant="danger ? 'danger' : 'primary'"
        :disabled="busy || !confirmable"
        :loading="busy"
        @click="$emit('confirm')"
      >{{ okLabel }}</aha-button>
    </template>
  </stripe-bridge-dialog>
</template>

<script>
import nativeAhaElements from './nativeAhaElements'
import StripeBridgeDialog from './StripeBridgeDialog'

export default {
  name: 'StripeBridgeConfirm',
  components: { ...nativeAhaElements, StripeBridgeDialog },
  props: {
    open: { type: Boolean, default: false },
    title: { type: String, required: true },
    okLabel: { type: String, default: 'Confirm' },
    danger: { type: Boolean, default: false },
    busy: { type: Boolean, default: false },
    error: { type: String, default: '' },
    requireText: { type: String, default: '' },
    disabled: { type: Boolean, default: false },
  },
  data() {
    return { typed: '' }
  },
  computed: {
    confirmable() {
      return !this.disabled && (!this.requireText || this.typed.trim() === this.requireText)
    },
  },
  watch: {
    open() {
      this.typed = ''
    },
  },
}
</script>

<style lang="scss" scoped>
.confirm-type {
  display: flex;
  flex-direction: column;
  gap: var(--aha-space-4);
}

.confirm-label {
  font-size: var(--aha-size-sm);
}
</style>
